import React from 'react';
import './scss/layout.scss';
import MainNav from './main-nav';
import Footer from './footer';
import LayoutProp from './properties/layout';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import 'bootstrap-icons/font/bootstrap-icons.css';

function Layout({ title, className, children }: LayoutProp): React.ReactElement {
  let heading;
  if (title) {
    heading = <h1>{title}</h1>;
  } else {
    heading = '';
  }
  return (
    <div className={className}>
      <MainNav />
      <main>
        <div className="container-fluid">
          {heading}
          {children}
        </div>
      </main>
      <Footer />
    </div>
  );
}

export default Layout;
